import { type IFileResponseEntity } from 'frontend/common/files/types/i-file-response-entity'
import { type IFileVariantResponseEntity } from 'frontend/common/files/types/i-file-variant-response-entity'
import mime from 'mime'

export function useActiveStorageBlobUrl() {
  function mapResourceImageToFileResponseEntity(resourceImage): IFileResponseEntity {
    const variants: IFileVariantResponseEntity[] = []
    if (resourceImage.urls) {
      Object.entries(resourceImage.urls).forEach(([key, value]: any) => {
        variants.push({
          key,
          dimensions: value.dimensions,
          limitDimensions: value.limitDimensions,
          url: value.path,
        })
      })
    }
    const fileName = resourceImage.urls?.original?.path?.split('/')?.pop() || 'Untitled file'
    const mimeType = mime.getType(fileName) || null
    return {
      uniqueId: resourceImage.id,
      fileName: fileName,
      contentType: mimeType,
      url: resourceImage.urls?.original?.path || null,
      customId: resourceImage.id,
      isPrimary: resourceImage.isPrimary,
      category: resourceImage.category,
      variants,
    }
  }

  return {
    mapResourceImageToFileResponseEntity,
  }
}
